module.exports = __webpack_public_path__ + "static/img/2.e581b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/2.png
// module id = 2GkV
// module chunks = 1